import React from 'react';

/**
 * Renders a Simple Icons brand glyph as an inline SVG.
 *
 * Simple Icons ships raw icon data (not React components), so pass an icon
 * object imported from `simple-icons`:
 *
 *   import { siWhatsapp } from 'simple-icons';
 *   <BrandIcon icon={siWhatsapp} size={28} color="#fff" />
 *
 * Defaults to the brand's official color (`icon.hex`).
 */
const BrandIcon = ({ icon, size = 24, color, title, style, className }) => {
  if (!icon) return null;
  return (
    <svg
      role="img"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={color || `#${icon.hex}`}
      style={style}
      className={className}
      aria-label={title || icon.title}
    >
      <title>{title || icon.title}</title>
      <path d={icon.path} />
    </svg>
  );
};

export default BrandIcon;
